module.exports = __webpack_public_path__ + "static/media/bytt-no-1.7f0216b5.mp3";